export default function Card({ children, className }) {
  return (
    <div className={"bg-cream/85 backdrop-blur shadow-lg shadow-stone-900/10 border border-white/40 rounded-2xl p-4 " + className}>
      {children}
    </div>
  );
}
